/**
 * @generated SignedSource<<75f84ab2986fd0f5b43d9da99fdd255e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TrainingSourceKind = "knowledge_base" | "web_crawl" | "%future added value";
export type TrainingSourceStatus = "error" | "processing" | "success" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type TrainingSourceTableListItemFragment$data = {
  readonly createdAt: string;
  readonly id: string;
  readonly kind: TrainingSourceKind;
  readonly name: string | null;
  readonly status: TrainingSourceStatus;
  readonly trainingData: {
    readonly totalCount: number;
  };
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceSettingsFormFragment">;
  readonly " $fragmentType": "TrainingSourceTableListItemFragment";
};
export type TrainingSourceTableListItemFragment$key = {
  readonly " $data"?: TrainingSourceTableListItemFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TrainingSourceTableListItemFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TrainingSourceTableListItemFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrainingDataNodeConnection",
      "kind": "LinkedField",
      "name": "trainingData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TrainingSourceSettingsFormFragment"
    }
  ],
  "type": "TrainingSource",
  "abstractKey": null
};

(node as any).hash = "bf579ac69ce49d017d8d49c89261fc92";

export default node;
